import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import { Form, FormikProps } from 'formik';
import React from 'react';
import FormLabel from '~/components/FormLabel/FormLabel';
import Input from '~/components/Input';
import Textarea from '~/components/Textarea';
import { WordsLeftCounter } from '~/components/WordsLeftCounter';

import { AboutYouValues } from './AboutYou.types';

export const AboutYou = React.forwardRef<
  HTMLFormElement,
  FormikProps<AboutYouValues>
>(
  (
    { errors, handleBlur, handleChange, handleSubmit, isSubmitting, values },
    ref,
  ) => {
    return (
      <>
        <Form onSubmit={handleSubmit} ref={ref}>
          <FormControl
            id="aboutMeName"
            isInvalid={!!errors.aboutMeName}
            marginBottom={6}
          >
            <FormLabel fontWeight={400} fontSize="md">
              Your name:
            </FormLabel>
            <Input
              value={values.aboutMeName}
              isDisabled={isSubmitting}
              onBlur={handleBlur}
              onChange={handleChange}
              placeholder="Example: Charlie Williams"
              size="md"
              type="text"
              width="100%"
              maxWidth="300px"
            />
            <FormErrorMessage data-testid="error-aboutMeName">
              {errors.aboutMeName}
            </FormErrorMessage>
          </FormControl>

          <FormControl
            id="aboutMeDescription"
            isInvalid={!!errors.aboutMeDescription}
            marginBottom={6}
          >
            <FormLabel fontWeight={400} fontSize="md">
              A little bit about you:
            </FormLabel>
            <Textarea
              value={values.aboutMeDescription}
              isDisabled={isSubmitting}
              maxLength={300}
              height="116px"
              onBlur={handleBlur}
              onChange={handleChange}
              placeholder="Example: My goal is to inspire, educate and entertain. I partner with brands I believe in, and find unique and interesting ways to integrate their story into my content. Smash that Contact Button. Let's do something great together..."
              fontSize="md"
              width="100%"
              maxWidth="360px"
            />
            <WordsLeftCounter
              maxLength={300}
              value={values.aboutMeDescription}
            />
            <FormErrorMessage data-testid="error-aboutMeDescription">
              {errors.aboutMeDescription}
            </FormErrorMessage>
          </FormControl>
        </Form>
      </>
    );
  },
);
